import React from 'react';

const TestPage = () => {
    return (
        <>
            <div className="container mt-4">
                <h1>Это тестовая страница</h1>
                <p>Контент страницы test.</p>
            </div>
        </>
    );
};

export default TestPage;
